<p>
  new-app-properties works!
</p>
